
<template>
    <div>
        <notifications group="system" position="top right" style="top:20vh"/>

        <div id="mySidenav" class="sidenav text-center d-flex flex-column pt-4 align-items-center" style="background-image: url('/images/header@2x.png')">
            <a href="javascript:void(0)" class="closebtn" @click="closeNav">&times;</a>

            <a href="#" class="mt-4" @click="closeNav"> {{ $t('general.solutions')}}</a>
            <a href="#" @click="closeNav">{{ $t('general.about_us')}} <span class="sr-only">(current)</span></a>
            <a href="#" @click="closeNav">{{ $t('general.pricing')}}</a>
            <a href="#" @click="closeNav">{{ $t('general.contacts')}}</a>

            <language-switcher class="mt-4" v-bind:switchUserLanguage="false"></language-switcher>
            <a href="javascript:void(0)" @click="closeNav" v-b-modal.order-a-call-modal> {{ $t('general.order_a_call') }} </a>
            <a href="javascript:void(Tawk_API.toggle())">
                {{$t('general.live_chat')}}
            </a>

            <a href="javascript:void(0)" class="mt-4 mb-3" @click="closeNav" v-b-modal.login-modal>{{ $t('general.login')}}</a>
            <a href="javascript:void(0)" @click="closeNav" class="btn-primary" v-b-modal.register-modal style="padding: 15px 30px">
                {{ $t('general.sign_up')}}
            </a>
        </div>

        <b-navbar toggleable="lg" type="dark" fixed="top">
            <div class="container-md align-items-md-baseline mt-4 mt-lg-2">
                <div class="d-lg-none w-100 d-flex justify-content-center mx-2">
                    <!--small screens-->
                    <router-link to="/" class="mt-0 mb-3 py-0">
                        <img class="img-fluid w-100" src="/images/logo@2x.png" alt="car transportation logo" style="max-width: 380px; padding: 0 5rem">
                    </router-link>

                    <div @click="openNav" class="navbar-toggler">
                        <i class="fas fa-bars"></i>
                    </div>
                </div>

                <b-collapse id="nav-collapse" is-nav style="min-height: 107px;">
                    <div class="d-flex flex-column w-100">
                        <div class="row justify-content-center justify-content-md-between">
                            <div class="col-auto d-none d-lg-block" style="width: 299px">
                                <router-link to="/" class="mt-2 mx-auto ml-lg-0 mr-lg-4" style="height: 56px">
                                    <img class="img-fluid" srcset="/images/logo.png 1x, /images/logo@2x.png 2x" alt="car transportation logo">
                                </router-link>
                            </div>
                            <div class="col-auto">
                                <ul class="navbar-nav align-items-center flex-row" style="margin-top: 0.4rem">
                                    <li class="nav-item mr-4">
                                        <a class="nav-link" href="#"> {{ $t('general.solutions')}}</a>
                                    </li>
                                    <li class="nav-item mr-4">
                                        <a class="nav-link" href="#">{{ $t('general.about_us')}} <span class="sr-only">(current)</span></a>
                                    </li>
                                    <li class="nav-item mr-4">
                                        <a class="nav-link" href="#">{{ $t('general.pricing')}}</a>
                                    </li>
                                    <li class="nav-item mr-4">
                                        <a class="nav-link" href="#">{{ $t('general.contacts')}}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-auto">
                                <ul class="navbar-nav align-items-center flex-row">
                                    <li class="nav-item mr-4 font-weight-bold">
                                        <a href="javascript:void(0)" class="nav-link" v-b-modal.login-modal>{{ $t('general.login')}}</a>
                                    </li>
                                    <li class="nav-item mr-4">
                                        <a href="javascript:void(0)" class="btn-primary" v-b-modal.register-modal>{{ $t('general.sign_up')}}</a>
                                    </li>
                                    <li class="nav-item pb-2">
                                        <language-switcher v-bind:switchUserLanguage="false"></language-switcher>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="navbar-row-info">
                            <div class="d-flex flex-column flex-md-row mb-2 w-100">
                                <ul class="justify-content-center justify-content-md-start text-center text-md-left ml-md-auto navbar-nav info flex-column flex-sm-row">
                                    <li class="nav-item mb-3 mb-md-0 mr-3 font-weight-bold">
                                        <img src="/images/headphones.svg" class="img-responsive mr-3" style="width: 1rem">
                                        {{ $t('general.247_support')}}
                                    </li>
                                    <li class="nav-item mb-3 mb-md-0 mr-3 font-weight-bold">
                                        <a href="#">
                                            {{ $t('general.support_phone')}}
                                        </a>
                                    </li>
                                    <li class="nav-item mb-3 mb-md-0 mr-3 font-weight-bold">
                                        <order-a-call @onTermsAndConditionsClick="forwardToTermsAndConditions"></order-a-call>
                                    </li>
                                    <li class="nav-item font-weight-bold">
                                        <a class="nav-link py-0 pr-0" href="javascript:void(Tawk_API.toggle())">
                                            {{$t('general.live_chat')}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </b-navbar>

        <header class="card-1" style="background-image: url('/images/header@2x.png')">
            <div class="container my-auto">
                <div class="row">
                    <div class="col text-center text-lg-left">
                        <h1> {{ $t('general.future_of_car_transport')}}</h1>
                        <p class="header-text-secondary mb-5"> {{ $t('general.hire_carrier_for_fraction_of_the_cost')}}</p>

                        <a class="btn-primary mr-3" href="javascript:void(0)" v-b-modal.log-reg-modal>{{$t('general.join_now')}}</a>
                        <a href="javascript:void(0)" class="text-white font-size-small">{{$t('general.explore_our_solutions')}}</a>
                    </div>
                    <div class="col-md-12 mt-5 mt-lg-0 col-lg-8 d-flex align-items-center justify-content-end flex-column flex-md-row">
                        <div class="workflow-card mt-4 mt-md-0">
                            <div class="h-100 w-100 d-flex justify-content-center">
                                <div class="workflow-card-content">
                                    <div class="d-flex justify-content-center">
                                        <img srcset="/images/loadTruck.png 1x, /images/loadTruck@2x.png 2x">
                                    </div>
                                    <div class="text-center">
                                        {{$t('general.workflow-card-1')}}
                                    </div>
                                </div>
                            </div>
                            <div class="workflow-card-dot-pattern"><img class="h-100" srcset="/images/dot_pattern.png 1x, /images/dot_pattern@2x.png 2x"></div>
                        </div>
                        <div class="workflow-arrow-parent">
                            <div class="workflow-arrow"><i class="fas fa-chevron-right center"></i></div>
                        </div>
                        <div class="workflow-card mt-4 mt-md-0">
                            <div class="h-100 w-100 d-flex justify-content-center">
                                <div class="workflow-card-content">
                                    <div class="d-flex justify-content-center">
                                        <img srcset="/images/group.png 1x, /images/group@2x.png 2x">
                                    </div>
                                    <div class="text-center">
                                        {{$t('general.workflow-card-2')}}
                                    </div>
                                </div>
                            </div>
                            <div class="workflow-card-dot-pattern"><img class="h-100" srcset="/images/dot_pattern.png 1x, /images/dot_pattern@2x.png 2x"></div>
                        </div>
                        <div class="workflow-arrow-parent">
                            <div class="workflow-arrow"><i class="fas fa-chevron-right center"></i></div>
                        </div>
                        <div class="workflow-card mt-4 mt-md-0">
                            <div class="h-100 w-100 d-flex justify-content-center">
                                <div class="workflow-card-content">
                                    <div class="d-flex justify-content-center">
                                        <img srcset="/images/pay.png 1x, /images/pay@2x.png 2x">
                                    </div>
                                    <div class="text-center">
                                        {{$t('general.workflow-card-3')}}
                                    </div>
                                </div>
                            </div>
                            <div class="workflow-card-dot-pattern"><img class="h-100" srcset="/images/dot_pattern.png 1x, /images/dot_pattern@2x.png 2x"></div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <section class="container card-3 my-5">
            <hr class="blue mt-5 mb-3">
            <h1 class="text-center my-3"> {{$t('general.freight_exchange')}} </h1>
            <div class="row">
                <div class="col-12 col-lg-7">
                    <div v-b-modal.table-lightbox class="text-right mr-md-5">
                        <img srcset="/images/table.png 1x, /images/table@2x.png 2x" class="img-fluid">
                    </div>

                    <b-modal id="table-lightbox" modal-class="lightbox" size="lg" title="BootstrapVue" hide-header hide-footer centered>
                        <div class="w-100 h-100" @click="$bvModal.hide('table-lightbox')">
                            <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('table-lightbox')">×</button>
                            <img src="/images/table-no-bg.png" class="img-fluid">
                        </div>
                    </b-modal>
                </div>
                <div class="col-12 col-lg d-flex align-items-center">
                    <div class="text-center text-lg-left w-100">
                        <div class="mt-5 mt-sm-0">
                            <h2 class="mb-5">{{$t('general.step_1')}}</h2>
                            <p  class="mb-5 text-gray-dark"> {{$t('general.step_1_description')}}</p>
                        </div>
                        <div>
                            <h2 class="mb-5">{{$t('general.step_2')}}</h2>
                            <p  class="mb-5 text-gray-dark"> {{$t('general.step_2_description')}}</p>
                        </div>
                        <div>
                            <h2 class="mb-5">{{$t('general.step_3')}}</h2>
                            <p  class="mb-5 text-gray-dark"> {{$t('general.step_3_description')}}</p>
                        </div>
                        <div>
                            <a class="btn-primary mr-lg-3" href="javascript:void(0)" v-b-modal.log-reg-modal>{{$t('general.join_now')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="px-md-2 pb-5 pt-0 text-center">
            <hr class="blue mt-5 mb-4">
            <h1 class="font-weight-bold mb-3">Choose your plan</h1>
            <packs-component class="pack-component justify-content-start justify-content-md-center" :packs="all"></packs-component>
            <div class="mt-4">
                <a class="btn-primary" href="javascript:void(0)" v-b-modal.log-reg-modal>{{$t('general.join_now')}}</a>
            </div>
        </section>

        <section class="card-4" style="background-image: url('/images/platform-comparison.png')">
            <div class="container-lg py-6">
                <div class="d-flex justify-content-center mb-5">
                    <h1 class="text-center mt-0" style="width: 550px">{{$t('general.platform_comparison')}}</h1>
                </div>
                <div class="row d-flex justify-content-center mx-auto" style="max-width: 80rem">
                    <div class="col-9 mt-md-0 col-md-4 platform-card text-center px-lg-5 card-seperator-side text-gray">
                        <div class="circle small mx-auto mb-3">
                            <h1 class="center">1</h1>
                        </div>
                        {{$t('general.platform_comparison_1')}}
                    </div>
                    <div class="col-9 mt-5 mt-md-0 col-md-4 platform-card text-center px-lg-5 card-seperator-side text-gray">
                        <div class="circle small mx-auto mb-3">
                            <h1 class="center">2</h1>
                        </div>
                        {{$t('general.platform_comparison_2')}}
                    </div>
                    <div class="col-9 mt-5 mt-md-0 col-md-4 platform-card text-center px-lg-5 card-seperator-side text-gray">
                        <div class="circle small mx-auto mb-3">
                            <h1 class="center">3</h1>
                        </div>
                        {{$t('general.platform_comparison_3')}}
                    </div>
                </div>
                <div class="text-center">
                    <a class="btn-primary mt-5 mb-0" href="javascript:void(0)" v-b-modal.log-reg-modal>{{$t('general.join_now')}}</a>
                </div>
            </div>
        </section>
        <section class="card-5 pt-5">
            <div class="container-lg p-0 p-md-2">
                <hr class="blue mb-3 mt-0">
                <h1 class="text-center mb-5">{{$t('general.what_our_users_say')}}</h1>
                <front-swiper class="mb-5"></front-swiper>
                <contact-form></contact-form>
            </div>
        </section>
        <footer style="background-image: url('/images/footer-bg@2x.png');">
            <div class="container p-5 text-center text-md-left">
                <div class="float-md-left">
                    <div class="mb-4" style="font-size: 0">
                        <a href="" target="_blank" class="social-button"><img src="/images/fb-icon.svg" class="img-fluid mr-2"></a>
                        <a href="" target="_blank" class="social-button"><img src="/images/insta-icon.svg" class="img-fluid mr-2"></a>
                        <a href="" target="_blank" class="social-button"><img src="/images/in-icon.svg" class="img-fluid"></a>
                    </div>
                    <div class="float-md-left mr-md-5 mb-4 mb-md-0">
                        {{ $t('general.company_adress_1')}} <br>
                        {{ $t('general.company_adress_2')}} <br>
                        {{ $t('general.company_adress_city')}}
                    </div>
                    <div class="float-md-right mb-4 mb-md-0">
                        <a href="javascript:void(0)" class="contact">{{ $t('general.support_phone_1')}} <br></a>
                        <a href="javascript:void(0)" class="contact">{{ $t('general.support_phone_2')}}</a>
                    </div>
                </div>
                <div class="float-md-right">
                    <div class="card-partner">
                        <img class="mx-auto" srcset="/images/norton-icon.jpg 1x, /images/norton-icon@2x.jpg 2x"  alt="Card image cap">
                    </div>
                    <div class="card-partner">
                        <img class="mx-auto" srcset="/images/etrust-icon.jpg 1x, /images/etrust-icon@2x.jpg 2x" alt="Card image cap">
                    </div>
                </div>
                <div class="clearfix"></div>
                <div>
                    <div class="float-md-left">
                        <div class="mt-3 mt-md-5">
                            <span>© {{year}}</span>
                            {{ $t('general.copyright')}}
                        </div>
                    </div>
                    <div class="float-md-right">
                        <div class="mt-3 mt-md-5">
                            <a href="javascript:void(0)" class="text-white mr-md-5 d-block d-md-inline" v-b-modal.terms-and-conditions-modal>{{$t('general.terms_and_conditions')}}</a>
                            <a href="javascript:void(0)" class="text-white" v-b-modal.privacy-modal>{{$t('general.privacy_policy')}}</a>

                            <b-modal id="terms-and-conditions-modal" hide-header hide-footer size="lg">
                                <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('terms-and-conditions-modal')">×</button>
                                <h1>{{$t('general.terms_and_conditions')}}</h1>
                                <p v-html="$t('general.terms_and_conditions_content')"></p>
                            </b-modal>
                            <privacy-policy-modal></privacy-policy-modal>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </footer>

        <div>
            <b-modal
                id="login-modal"
                hide-header
                hide-footer
                centered
                content-class="login-modal">
                <div class="collapse show" id="login-modal-main">
                    <h1>{{$t('general.login_modal_title')}}</h1>
                    <login :loginButtonClass="'btn btn-primary w-100'"></login>

                    <a href="javascript:void(0)" class="d-block font-size-small mb-0 mt-2" @click="collapseShow('#login-modal', '#login-modal-forgot-password')">
                        {{$t('general.password_reset_title')}}
                    </a>
                </div>

                <div class="collapse" id="login-modal-forgot-password">
                    <password-reset-form :sendResetLinkClass="'btn btn-primary w-100'"></password-reset-form>
<!--                    <a href="#" class="d-inline font-size-small" @click="collapseShow('#login-modal', '#login-modal-main')"> {{$t('general.back')}} </a>-->
                </div>

                <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('login-modal')">×</button>
            </b-modal>

            <b-modal
                id="register-modal"
                hide-header
                hide-footer
                centered
                content-class="register-modal">
                <div class="collapse show" id="register-modal-main">
                    <h1>{{$t('general.register_modal_title')}}</h1>
                    <register :submitButtonClass="'btn btn-primary w-100'"></register>
                    <a href="javascript:void(0)" class="d-block font-size-small mb-0 mt-2" @click="collapseShow('#register-modal', '#register-modal-resend')">
                        {{$t('general.resend_email_verification')}}
                    </a>
                </div>
                <div class="collapse" id="register-modal-resend">
                    <email-verification-resend-form></email-verification-resend-form>
<!--                    <a href="#" class="d-inline font-size-small" @click="collapseShow('#register-modal', '#register-modal-main')">-->
<!--                        {{$t('general.back')}}-->
<!--                    </a>-->
                </div>
                <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('register-modal')">×</button>
            </b-modal>

            <b-modal id="log-reg-modal"
                     class="p-0"
                     content-class="log-reg-modal text-center text-md-left"
                     size="lg"
                     centered
                     hide-header
                     hide-footer>
                <div class="collapse show" id="log-reg">
                    <div class="row">
                        <div class="col-12 col-md-6 pr-md-5 log-reg-modal-border">
                            <h1>{{$t('general.login')}}</h1>
                            <login
                                :loginButtonClass="'btn btn-primary w-100'">
                            </login>

                            <a href="javascript:void(0)" class="d-block font-size-small mb-0 mt-2" @click="collapseShow('#log-reg-modal', '#log-reg-forgot-pass')">
                                {{$t('general.password_reset_title')}}
                            </a>
                            <a href="javascript:void(0)" class="d-block font-size-small mb-0" @click="collapseShow('#log-reg-modal', '#log-reg-resend-email-verification')">
                                {{$t('general.resend_email_verification')}}
                            </a>
                        </div>

                        <div class="col-12 d-md-none">
                            <hr class="my-4">
                            <div class="center font-weight-bold" style="background-color: white; color: rgb(213 213 213);">
                                {{$t('general.loginOrRegister')}}
                            </div>
                        </div>

                        <div class="col-12 col-md-6 pl-md-5">
                            <h1>{{$t('general.register')}}</h1>
                            <register :submitButtonClass="'btn btn-primary w-100'"></register>
                        </div>

                        <div class="d-none d-md-block center font-weight-bold" style="background-color: white; color: rgb(213 213 213);">
                            {{$t('general.loginOrRegister')}}
                        </div>
                    </div>
                </div>

                <div class="collapse" id="log-reg-forgot-pass">
                    <password-reset-form :sendResetLinkClass="'btn-primary w-100 mb-0'"></password-reset-form>
<!--                    <a href="#" class="d-inline" @click="collapseShow('#log-reg-modal', '#log-reg')"> {{$t('general.back')}} </a>-->
                </div>

                <div class="collapse" id="log-reg-resend-email-verification">
                    <email-verification-resend-form></email-verification-resend-form>
<!--                    <a href="#" class="d-inline" @click="collapseShow('#log-reg-modal', '#log-reg')"> {{$t('general.back')}} </a>-->
                </div>

                <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('log-reg-modal')">×</button>
            </b-modal>
        </div>
        <cookie-consent></cookie-consent>
    </div>
</template>

<style lang="scss" scoped>
    @use "./resources/sass/client/breakpoints" as br;

    body {
        background-color: #112F74;
    }
    .pack-component {
        grid-template-columns: repeat(auto-fit, 20rem) !important;
        margin: 3rem 0 !important;
        gap: 2rem !important;

        @media (max-width: br.$breakpoint-md) {
            grid-template-columns: unset !important;
            gap: 1rem !important;

            ::v-deep .card {
                min-width: 21rem !important;
            }
        }

        ::v-deep {
            .card {
                font-size: 1.2rem;

                @media (min-width: br.$breakpoint-md) {
                    &.main {
                        transform: scale(1.05);
                    }
                }
            }
        }
    }
</style>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Index.vue",
        props: {
            year: String,
        },
        data() {
            return {
                oldScrollY: 0,
                navbarTop:0,
            }
        },
        mounted() {
            document.addEventListener('scroll', this.navScroll);
            this.navScroll();

            if (this.$route.query.verified === '1') {
                this.$notify({
                    group: "system",
                    title: this.$t('general.success'),
                    text: this.$t('general.email_verified_message'),
                    type: "success"
                });
            }
        },
        created() {
            this.fetchDataMinimal();
        },
        computed:{
            ...mapGetters('PacksIndex', ['all']),
        },
        methods: {
            ...mapActions('PacksIndex', ['fetchDataMinimal']),

            collapseHideAll (parent) {
                let elements = $(parent).find($(".collapse"));
                elements.collapse('hide');

                $(parent).find($('.invalid-feedback')).hide();
            },
            collapseShow (parent, param) {
                this.collapseHideAll(parent);
                let element = $(parent).find($(param));
                element.collapse('show');
            },
            toggleNavbar () {
                let navbar = $('.navbar').first();
                let navbarToggler = $('.navbar-toggler').first();
                if (!navbarToggler.hasClass('not-collapsed')) {
                    navbar.addClass('not-collapsed');
                } else {
                    navbar.removeClass('not-collapsed');
                }
            },
            navScroll () {
                // if (window.scrollY > 0) {
                //     return;
                // }

                let scrollDelta = this.oldScrollY-window.scrollY;
                this.oldScrollY = window.scrollY;

                this.navbarTop += scrollDelta;

                if (scrollDelta > 0) {
                    let navbarHeight = document.getElementsByTagName('nav')[0].offsetHeight;
                    this.navbarTop = Math.max(-navbarHeight, this.navbarTop);
                    if (this.navbarTop > 0) {
                        this.navbarTop = 0;
                    }
                }

                let navbar = document.getElementsByTagName('nav')[0];
                if (window.scrollY < 1) {
                    if (!navbar.classList.contains("navbar-top"))
                        navbar.classList.add("navbar-top");

                    navbar.classList.remove("navbar-scroll");
                } else {
                    if (scrollDelta > 0 && navbar.classList.contains("navbar-top")) {
                        navbar.classList.remove("navbar-top");
                        navbar.classList.add("navbar-scroll");
                    }
                }

                navbar.style.top = `${this.navbarTop}px`;
            },
            openNav() {
                document.getElementById("mySidenav").style.width = "100%";
            },
            closeNav() {
                document.getElementById("mySidenav").style.width = "0";
            },
            forwardToTermsAndConditions () {
                this.$bvModal.show('terms-and-conditions-modal');
            },
        }
    }
</script>
